import { useCallback, useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import ReactPaginate from "react-paginate";
import AdminPanelSideBar from "../AdminComponents/AdminPanelSideBar";
import DashboardSideBar from "../DashboardComponents/DashboardSideBar";
import { truncateDescription } from "../../utils/truncateDescritopn";
import { fetchUserDonations } from "../../utils/PostComponents";

const Base_Url = process.env.REACT_APP_BASE_URL;

const Donations = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page")) || 1;

  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const role = localStorage.getItem("role");

  const updateUrlParams = useCallback(
    async (newPage, newLimit) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("page", newPage);
      searchParams.set("limit", newLimit);
      navigate({ search: searchParams.toString() });
    },
    [location.search, navigate]
  );

  useEffect(() => {
    setLoading(true);
    fetchUserDonations(setPosts, page, limit, setTotalPages, searchQuery);
    updateUrlParams(page, limit);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [page, searchQuery, limit, updateUrlParams, location.pathname]);

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setPage(1);
    updateUrlParams(1, newLimit);
  };

  const handleViewPost = (post) => {
    navigate(`/view/post/${post._id}`);
  };

  const handlePageChange = (selectedPage) => {
    const newPage = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    setPage(newPage);
    updateUrlParams(newPage, limit);
  };

  const handleSearch = (e) => {
    setLoading(true);
    setSearchQuery(e.target.value);
    setPage(1);
    updateUrlParams(1, limit);
  };

  return (
    <>
      <Header />
      <div className="below-header">
        <p>
          <NavLink to={"/"}>Home</NavLink>
          <span>/</span>
          <a href={location.pathname} className="aCustom">My Donations</a>
        </p>
      </div>
      <div className="flex-screen custom_section donations_page">
        {role === "admin" ? <AdminPanelSideBar /> : <DashboardSideBar />}
        <div className="aligned-container">
          <div className="custom_container">
            <div className="search-container search_head">
              <div className="topHeading">
                <h2>Donations</h2>
              </div>
              <div className="search_box">
                <input
                  type="text"
                  placeholder="Search donations by title"
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </div>
            </div>

            {loading ? (
              <div className="container loading-dots">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>
            ) : (
              <>
                {!loading &&
                  (posts && posts.length > 0 ? (
                    <div className="post-container">
                      {posts.map((post) => (
                        <div className="post-card" key={post._id}>
                          <div className="card-image">
                            <img
                              src={`${Base_Url}/assets/postThumbnails/${post.attachment}`}
                              alt="Post Img"
                            />
                          </div>
                          <div className="card-content">
                            <h3 className="post-title">{post.title}</h3>
                            <p
                              className="description"
                              dangerouslySetInnerHTML={{
                                __html: truncateDescription(
                                  post.description,
                                  30
                                ),
                              }}
                            ></p>
                            <p className="amount">
                              <b>Total amount : </b> ${post.amount}
                            </p>
                            <p className="amount">
                              <b>Total Paid : </b> ${post.paidAmount}
                            </p>
                            <p className="amount">
                              <b>Paid amount by me : </b> $
                              {post.paidBy[0].amount}
                            </p>
                            <div className="donate-btns">
                              <button
                                className="donate-btn"
                                onClick={() => handleViewPost(post)}
                              >
                                View
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="post-container">No Donations Found</div>
                  ))}

                {!loading && (
                  <>
                    <div className="blog-paginate">
                      <div className="limit-selection">
                        <label htmlFor="limit">Donations per page: </label>
                        <select
                          id="limit"
                          value={limit}
                          onChange={handleLimitChange}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                        </select>
                      </div>

                      {posts &&
                        posts.length > 0 &&
                        totalPages &&
                        totalPages > 1 && (
                          <ReactPaginate
                            pageCount={totalPages}
                            onPageChange={handlePageChange}
                            containerClassName="pagination"
                            previousLabel={"<"}
                            nextLabel={">"}
                            breakLabel={"..."}
                            pageClassName={"page-item"}
                            activeClassName={"active"}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            forcePage={page - 1} // Sync with current page
                          />
                        )}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Donations;
